export const getIsMetamaskInjected = (): boolean => {
  const { ethereum } = window;

  if (!ethereum) {
    return false;
  }

  return true;
};
